var CampaignType = /* @__PURE__ */ ((CampaignType2) => {
  CampaignType2["MembershipRewardCampaign"] = "promoteBrandClubRewardCampaign";
  CampaignType2["PurchaseRewardCampaign"] = "purchaseRewardCampaign";
  CampaignType2["SurveyRewardCampaign"] = "surveyRewardCampaign";
  CampaignType2["DailyDealsRewardCampaign"] = "limitedTimePurchaseRewardCampaign";
  CampaignType2["RatingCampaign"] = "reviewRewardCampaign";
  CampaignType2["AffiliateRewardCampaign"] = "affiliateLinkCampaign";
  CampaignType2["ContentRewardCampaign"] = "contentRewardCampaign";
  CampaignType2["ReferralRewardCampaign"] = "referralRewardCampaign";
  CampaignType2["RetailerConnectRewardCampaign"] = "retailerConnectRewardCampaign";
  return CampaignType2;
})(CampaignType || {});
var BrandclubEntityType = /* @__PURE__ */ ((BrandclubEntityType2) => {
  BrandclubEntityType2["Audience"] = "audience";
  BrandclubEntityType2["Brand"] = "brand";
  BrandclubEntityType2["Category"] = "category";
  BrandclubEntityType2["Subcategory"] = "subCategory";
  BrandclubEntityType2["CustomCategoryGroup"] = "customCategoryGroup";
  BrandclubEntityType2["Campaign"] = "campaign";
  BrandclubEntityType2["CompanyDivision"] = "companyDivision";
  BrandclubEntityType2["Customer"] = "customer";
  BrandclubEntityType2["Product"] = "product";
  BrandclubEntityType2["Reward"] = "reward";
  BrandclubEntityType2["Profile"] = "profile";
  return BrandclubEntityType2;
})(BrandclubEntityType || {});
export {
  BrandclubEntityType,
  CampaignType
};
//# sourceMappingURL=Campaign.js.map
